import { render, staticRenderFns } from "./CodeTab.vue?vue&type=template&id=2410c06d&scoped=true"
import script from "./CodeTab.vue?vue&type=script&lang=js"
export * from "./CodeTab.vue?vue&type=script&lang=js"
import style0 from "./CodeTab.vue?vue&type=style&index=0&id=2410c06d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410c06d",
  null
  
)

export default component.exports